import React from 'react';
import Icon from './icons';

export default function Modal({ title, onClose, children, footer, wide }) {
  return (
    <div className="modal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className={`modal-panel${wide ? ' modal-panel--wide' : ''}`}>
        <div className="modal-panel__header">
          <h3>{title}</h3>
          <button type="button" className="modal-panel__close" onClick={onClose} aria-label="Close">
            <Icon name="close" />
          </button>
        </div>
        <div className="modal-panel__body">{children}</div>
        {footer && <div className="modal-panel__footer">{footer}</div>}
      </div>
    </div>
  );
}
